module.exports = __webpack_public_path__ + "img/access-levels-research.d5bad033.png";